import React from 'react';
import styled from 'App/styled';
import StarIcon from 'components/Icons/Star';
import EmptyStar from './EmptyStar';

interface StarImageProps {
  ratingCount: number;
}
const Icon = styled.i`
  display: inline-block;
  margin-right: ${({ theme }) => theme.spacing.spacing10};
  @media (min-width: 768px) and (max-width: 1024px) {
    ${({ theme }) => theme.typography.bodyMedium};
    svg {
      width: 15px;
      height: 15px;
    }
  }
`;
const StarImage = ({ ratingCount }: StarImageProps) => (
  <>
    {[...Array(5)].map((star, index) => (
      <span
        key={`${index}-${star}`}
        aria-hidden="true"
      >
        <Icon>{index < ratingCount ? <StarIcon /> : <EmptyStar />}</Icon>
      </span>
    ))}
  </>
);
export default StarImage;
